// extracted by extract-css-chunks-webpack-plugin
module.exports = {"pdpWidget":"SuburbBlurb__pdpWidget--cUDZ0","srpWidget":"SuburbBlurb__srpWidget--WMGCm"};